module.exports = __webpack_public_path__ + "img/9788964950883.1141c3e1.jpg";